<!--确认销售退货付款页面-->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
    </div>
    <div class="section-title">
      <div>申请付款记录</div>
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{ background: '#F2F6FC' }"
        :data="receiptRecords"
        border
        show-summary
        :summary-method="getSummaries_apply" 
        style="width: 100%; margin-bottom: 10px; margin-top: 0px"
      >
        <el-table-column
          show-overflow-tooltip
          width="190px"
          prop="PayCode"
          label="单号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          prop="SumPayable"
          label="订单总金额"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="AlreadyPaid"
          label="已付款金额"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          width="150px"
          prop="ApplyPay"
          label="申请付款金额"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          prop="NowPay"
          label="实付金额"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="Unpaid"
          label="剩余申请金额"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          width="80px"
          prop="PayTypeName"
          label="结算方式"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80px"
          prop="ApplyName"
          label="申请人"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="160px"
          prop="CreateTime"
          label="申请时间"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="100px"
          prop="Remark"
          label="备注"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div
              class="ops-ctn"
              v-if="
                !scope.row.IsConfirm &&
                !scope.row.IsCancel &&
                permission.salesReturnsPaymentFunc &&
                action == 'cpayment'
              "
            >
              <el-button
                title="确认"
                size="mini"
                type="text"
                @click="confirmPayRecord(scope.row)"
                >{{ permission.salesReturnsPaymentFunc }}</el-button
              >
            </div>
            <div
              class="ops-ctn"
              v-else-if="
                !scope.row.IsConfirm &&
                !scope.row.IsCancel &&
                permission.editAndConfirm &&
                action == 'cpayment'
              "
            >
              <el-button
                title="确认"
                size="mini"
                type="text"
                @click="showConfirmDialog(scope.row)"
                >{{ permission.editAndConfirm }}</el-button
              >
            </div>
            <div
              class="ops-ctn"
              v-else-if="
                (action != 'cpayment' || permission.salesReturnsPaymentFunc) &&
                !scope.row.IsConfirm &&
                !scope.row.IsCancel
              "
            >
              未确认
            </div>
            <div
              class="ops-ctn"
              v-else-if="!scope.row.IsConfirm && scope.row.IsCancel"
            >
              已撤销
            </div>
            <div
              class="ops-ctn"
              v-else-if="scope.row.IsConfirm && !scope.row.IsCancel"
            >
              已确认
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--   form   -->
    <div class="section-title">
      <div>
        <span>售后订单信息</span>
      </div>
    </div>
    <div class="search-ctn">
      <el-form
        :model="submitData"
        ref="formMsg"
        label-width="100px"
        style="width: 100%; padding-right: 30px; padding-left: 30px"
      >
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <el-form-item label="客户" prop="EntpCusName">
                <el-input
                  type="text"
                  style="width: 100%"
                  v-model="submitData.EntpCusName"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="售后时间" prop="ReturnTime">
                <el-input
                  type="text"
                  style="width: 100%"
                  v-model="submitData.ReturnTime"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple">
              <el-form-item label="售后原因" prop="Reasons">
                <el-input
                  type="text"
                  style="width: 100%"
                  v-model="submitData.Reasons"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--    table    -->
    <div class="section-title" v-if="dataList && dataList.length > 0">
      <div>退货商品明细</div>
    </div>

    <div class="edit-ctn" id="editCtn" v-if="dataList && dataList.length > 0">
      <div class="table-main">
        <el-table
          :header-cell-style="{ background: '#F2F6FC' }"
          :data="dataList"
          ref="multipleTable"
          :summary-method="getSummaries"
          show-summary
          border
          style="width: 100%"
        >
          <el-table-column
          show-overflow-tooltip
          min-width="170px"
          prop="APCode"
          label="汽配编码"
          >
            <template slot-scope="scope">
              <div class="apcode-cell">
                <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(scope.row.GoodsId)" />
                <span>{{ scope.row.APCode }}</span>
                <el-tag v-if="scope.row.State == 1" class="tag" type="warning" size="small">已删除</el-tag>
              </div>
            </template>
          </el-table-column>     
          <el-table-column
          show-overflow-tooltip
          min-width="200px"
          prop="GoodName"
          label="配件名称"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="160px"
          prop="AutoSerise"
          label="车型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="Unit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="ReturnCount"
          label="退货数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="ReturnPrice"
          label="退单价"
        ></el-table-column>      
        <el-table-column
          show-overflow-tooltip
          width="150px"
          prop="ReturnTotalPrice"
          label="退单总价"
        >
            <template v-slot="{ row }">
            <span> {{(row.ReturnPrice * row.ReturnCount).toFixed(2)}}</span>
            </template>      
        </el-table-column>   
        <!-- <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="IsAlreadyOut"
          label="出仓状态"
        >
            <template v-slot="{ row }">
            <span>{{ item.IsAlreadyOut ? "已出仓" : "未出仓" }}</span>
            </template>      
        </el-table-column>                   -->
        </el-table>      
      </div>
    </div>


    <!--   配件信息     -->
    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
    <el-dialog
      :close-on-click-modal="false"
      title="确认付款"
      :visible.sync="ReceiptVisible"
      width="1000px"
    >
      <div class="dialog-content" v-if="ReceiptVisible">
        <confirmEditReceipt
          @closeReceipt="closeReceipt"
          :receiptData="receiptData"
          :type="3"
        ></confirmEditReceipt>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import APMsg from "@/components/common/APMsg";
import confirmEditReceipt from "@/components/business/revenue/confirmReceiptOrPayment";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    APMsg,
    breadcrumb,
    confirmEditReceipt,
  },
  data() {
    return {
      ReceiptVisible: false,
      download_url: this.$util.QN_URL_BASE,
      EntpTempGoodsIdEdit: "",
      canRequest: true,
      showOrderMsg: true,
      APMsgVisible: false,
      editIndex: -1,
      submitData: {
        EntpCusName: "",
        SReturnId: "",
        EntpCusOId: "",
        ReturnTime: "",
        Reasons: "",
        ReturnMoney: 0,
        SubmissionState: 0,
        DetailList: [],
      },
      dataList: [],
      action: "", //操作类型 see 查看 creceipt 确认收款
      SReturnId: "",
      pageTitle: "确认付款",
      permission: {},
      receiptRecords: [],
      receiptRecordsCount: 0,
      confirmPayRecordData: {
        Id: "",
        OperateType: 1
      },
      receiptData: {},
    };
  },
  mounted() {
    let that = this;
    that.permission = this.$util.getPermission("salesReturnsPayment");
    that.SReturnId = this.$route.query.SReturnId;
    that.action = this.$route.query.action;
    if (that.action == "see") this.pageTitle = "订单详情";

    that.getOrderDetail();
    that.getReceiptRecords();
  },
  methods: {
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog(edit) {
      this.APMsgVisible = false;
      if (edit) {
        this.getOrderDetail();
      }
    },

    // 获取详情
    getOrderDetail() {
      let that = this;
      that.$util
        .axiosGet({
          url:
            "/api/EntpSaleReturnOrder/GetOrderDetailRefund",
          data: {
            SReturnId: that.SReturnId,
          },
        })
        .then((res) => {
          let data = res.data;
          let DetailList = data.DetailList;
          that.submitData = data;
          that.dataList = DetailList;
        })
        .catch((err) => {});
    },
    //付款记录列表
    getReceiptRecords() {
      this.$util
        .axiosGet({
          url:
            "/api/EntpSaleOrder/GetPaymentAndReceiptRecordsByOId",
          data: {
            orderId: this.SReturnId,
          },
        })
        .then((res) => {
          let data = res.data;
          this.receiptRecordsCount = res.count;
          this.receiptRecords = data;
        })
        .catch((err) => {});
    },
    //确认付款
    confirmPayRecord(item) {
      if (item && item.Id) {
        this.$confirm("是否确认付款？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.confirmPayRecordData.Id = item.Id;
            this.$util
              .axiosPost({
                url:
                  "/api/EntpSaleOrder/OperatePaymentAndReceiptRecord",
                data: this.confirmPayRecordData,
              })
              .then((res) => {
                this.$util.successMsg("确认付款成功");
                this.$store.commit("updateNeedRefresh", true);
                item.IsConfirm = true;
              })
              .catch(() => {});
          })
          .catch(() => {});
      } else {
        this.$util.warningMsg("请选择有效的付款记录");
      }
    },
    showConfirmDialog(item) {
      if (item && item.Id) {
        this.receiptData = item;
        this.ReceiptVisible = true;
      } else {
        this.$util.warningMsg("请选择有效的付款记录");
      }
    },
    closeReceipt(edit) {
      this.ReceiptVisible = false;
      if (edit) {
        this.getReceiptRecords();
        this.$store.commit("updateNeedRefresh", true);
      }
    },
    getSummaries_apply(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index===2){
          let totalAmount=0
          if(data.length>0)
            totalAmount=Number(data[0].SumPayable);
          let applyTotal= data.reduce((prev, curr) => {
            if(curr.IsCancel)
              return prev;
            else
              return prev +Number(curr.ApplyPay);
          }, 0) ;         
          sums[index] = '剩余可申请：'+(totalAmount>applyTotal?totalAmount-applyTotal:0).toFixed(2);          
          return;
        }else if (index===3){
          let sum=data.reduce((prev, curr) => {
            if(curr.IsCancel||!curr.IsConfirm)
              return prev;
            else
              return prev +Number(curr.NowPay);
          }, 0)
          sums[index] = '已付：'+sum.toFixed(2);             
          return;
        }
        else{
          sums[index] ="";
          return;
        }
      });
      return sums;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计：";
          return;
        }else if (index === 4) {
          sums[index] = data.reduce((prev, curr) => {return prev +Number(curr.ReturnCount)},0);
          return;
        }else if (index === 6){
           let sum= data.reduce((prev, curr) => {return prev +Number(curr.ReturnCount)*Number(curr.ReturnPrice)},0);
           sums[index] =sum.toFixed(2);
          return;
        }else{
          return "";
        }
      });
      return sums;
    },          
  },
};
</script>
<style lang="less" scoped>
.payment-tip {
  position: absolute;
  left: 0;
  bottom: -18px;
  line-height: 1;
  font-size: 12px;
  color: @font4Color;
}
.form-main {
  display: flex;
  align-items: center;
}
.inventory-title {
  line-height: 1.2;
  flex-direction: column;
  > div:nth-child(1) {
    width: 100%;
    border-bottom: 1px solid @border3Color;
  }
  > div:nth-child(2) {
    width: 100%;
    display: flex;
    > div {
      width: 33.33%;
    }
  }
}
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 10px;
  margin-bottom: 10px;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.form-section {
  display: flex;
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.business-content-main {
  padding-right: 80px;
}
.table-main {
  position: relative;
}
.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}
.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-grow: 1;
}
.table-item {
  height: 50px;
  position: relative;
}
.div-table-row {
  overflow: inherit;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
